import { useState, useCallback, useEffect } from "react";
import { PIN_SCHEDULE } from "../data/pinSchedule";

function getPhTime() {
  const now = new Date();
  const ph = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Manila" }));
  ph.setHours(0, 0, 0, 0);
  return ph;
}

function getCurrentSchedule() {
  const today = getPhTime();
  return (
    PIN_SCHEDULE.find((entry) => {
      const [fy, fm, fd] = entry.from.split("-").map(Number);
      const [ty, tm, td] = entry.to.split("-").map(Number);
      const from = new Date(fy, fm - 1, fd, 0, 0, 0, 0);
      const to = new Date(ty, tm - 1, td, 23, 59, 59, 999);
      return today >= from && today <= to;
    }) || null
  );
}

function getUsedCount(scheduleKey) {
  try {
    const stored = localStorage.getItem(`used_count_${scheduleKey}`);
    return stored ? parseInt(stored) : 0;
  } catch {
    return 0;
  }
}

function incrementUsedCount(scheduleKey) {
  try {
    const count = getUsedCount(scheduleKey);
    localStorage.setItem(`used_count_${scheduleKey}`, count + 1);
  } catch {}
}

function checkPin(enteredPin) {
  const schedule = getCurrentSchedule();
  if (!schedule) return "no_schedule";

  const scheduleKey = schedule.from;
  const usedCount = getUsedCount(scheduleKey);
  const currentPin = schedule.pins[usedCount];

  if (!currentPin) return "no_more_pins";
  if (enteredPin !== currentPin) return "wrong";

  incrementUsedCount(scheduleKey);
  return "success";
}

function getPrefilledDigits() {
  return [];
}

export function usePinInput({ onSuccess } = {}) {
  const [digits, setDigits] = useState(() => getPrefilledDigits());
  const [status, setStatus] = useState("idle");
  const [shake, setShake] = useState(false);

  const triggerShake = useCallback(() => {
    setShake(true);
    setTimeout(() => setShake(false), 600);
  }, []);

  const handleKey = useCallback(
    (key) => {
      if (status === "success" || status === "error") return;
      if (digits.length >= 6) return;

      const next = [...digits, key];
      setDigits(next);

      if (next.length === 6) {
        const result = checkPin(next.join(""));

        if (result === "success") {
          setStatus("success");
          onSuccess?.();
        } else {
          setStatus("error");
          triggerShake();
        }
      }
    },
    [digits, status, onSuccess, triggerShake]
  );

  useEffect(() => {
    const handleStorage = () => {
      window.location.reload();
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const handleDelete = useCallback(() => {
    if (status === "success" || status === "error") return;
    setDigits((prev) => prev.slice(0, -1));
  }, [status, digits]);

  const reset = useCallback(() => {
    setStatus("idle");
    setShake(false);
    setDigits(getPrefilledDigits());
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key >= "0" && e.key <= "9") handleKey(e.key);
      if (e.key === "Backspace") handleDelete();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [handleKey, handleDelete]);

  return {
    digits,
    status,
    shake,
    handleKey,
    handleDelete,
    reset,
  };
}